import React, { useEffect } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { ALBUMS } from '@disco/constants/FeatureTypes'
import { useTranslation } from '@disco/i18n/use-translation'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getClientLibrary } from '@disco/state-management/selectors/client-libraries'

import type { ClientLibrary } from 'types/client-library'
import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import LibraryAlbumsManager from 'components/libraries/library-albums-manager'
import { getAlbumLabels } from 'components/libraries/library-albums-manager/album-labels'
import PageContainer from 'components/ui/page-container'

import { useSelector } from 'hooks/use-redux'

const LibrariesLibraryAlbums = (): React.ReactNode => {
  const params = useParams<{ libraryId: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation('catalogs-management')
  const labels = getAlbumLabels(t, 'albums')
  const libraryId: number = parseInt(params.libraryId!, 10)
  const albumsEnabled: string | boolean = useFeatureEnabled(ALBUMS)
  useEffect(() => {
    if (!albumsEnabled) {
      navigate(`/catalogs/${libraryId}`)
    }
  }, [albumsEnabled, navigate, libraryId])
  const library: ClientLibrary = useSelector((state: State) =>
    getClientLibrary(state, libraryId),
  )

  return (
    <PageContainer>
      <PageContainer.Section
        title={labels.title}
        description={labels.description}
      >
        {library && !library['loading'] && (
          <DocumentHeadTags
            title={t(
              'catalogs-management:catalogAlbumsDisco',
              '{{name}} | Albums | DISCO',
              { name: library['name'] },
            )}
          />
        )}
        <LibraryAlbumsManager
          libraryId={libraryId}
          basePath={`/catalogs/${libraryId}/albums`}
          variant="albums"
        />
        <Outlet />
      </PageContainer.Section>
    </PageContainer>
  )
}

export default LibrariesLibraryAlbums
